/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class ETransportShipmentDataDTO extends JSONable {
  licensePlate: string | null = null;
  firstTrailerLicensePlate: string | null = null;
  secondTrailerLicensePlate: string | null = null;
  shipmentOrganizerCountryCode: string | null = null;
  shipmentOrganizerCode: string | null = null;
  shipmentOrganizerAsIndividual = false;
  shipmentOrganizerName: string | null = null;
  shipmentDate: string | null = null;
  shipmentOrganizerLegalEntityUuid: string | null = null;
  shipmentOrganizerUuid: string | null = null;
}
